export const SignupSteps = {
    signup: 1,
    otp: 2,
    terms: 3,
    kyc: 4,
    absher: 5,
    nafath: 6,
    personalInfo: 7
} as const;